import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

import TextField from 'components/DesignSystem/TextField';
import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import SheetActionButton from 'components/Layout/MobileShell/SheetActionButton';
import StudyHorizon from 'components/Flux/Personalized/New/Form/Accordion/studyHorizon';
import OutputOptions from 'components/Flux/Personalized/New/Form/Accordion/outputOptions';
import PrevivazModel from 'components/Flux/Personalized/New/Form/Accordion/previvazModel';
import MultiScenarios from 'components/Flux/Personalized/New/Form/Accordion/multiScenarios';
import useNewStudyForm from 'utils/hooks/flux/personalized/useNewStudyForm';

import 'components/Flux/Upload/Mobile/Form/index.scss';
import './index.scss';

type SectionKey = 'horizon' | 'output' | 'previvaz' | 'scenarios';

const countLabel = (total: number, gender: 'f' | 'm' = 'f') => {
  if (total === 0) {
    return gender === 'f' ? 'Nenhuma' : 'Nenhum';
  }

  const suffix = total === 1 ? '' : 's';

  return `${total} selecionad${gender === 'f' ? 'a' : 'o'}${suffix}`;
};

export default function PersonalizedFormMobile() {
  const {
    name, setName, endDate, outputOptions, multiScenarios, previvazModel,
    addScenarioDisabled, onAddScenarioClick, onCancelClick, horizonsDisabled,
  } = useNewStudyForm();

  const [openSection, setOpenSection] = useState<SectionKey | null>(null);

  const toggle = (key: SectionKey) => {
    setOpenSection(openSection === key ? null : key);
  };

  const horizonText = endDate
    ? `até ${new Date(endDate * 1000).toLocaleDateString('pt-BR')}`
    : 'Sem data final';

  return (
    <section className="upload-form-mobile personalized-form-mobile">
      <h2 className="upload-form-mobile-title">Novo Estudo · Configuração</h2>

      <div className="upload-form-mobile-field">
        <TextField
          controlId="personalized-mobile-study-name"
          className="upload-form-mobile-name-field"
          label="Nome do Estudo"
          required
          type="text"
          placeholder="Digite o nome do estudo"
          value={name}
          onChange={(e) => { setName(e.target.value); }}
        />
      </div>

      <Section
        label="Horizonte do Estudo"
        valueText={horizonText}
        open={openSection === 'horizon'}
        onToggle={() => toggle('horizon')}
      >
        <StudyHorizon />
      </Section>

      <Section
        label="Opções de Saída"
        valueText={countLabel(outputOptions.length)}
        open={openSection === 'output'}
        onToggle={() => toggle('output')}
      >
        <OutputOptions />
      </Section>

      <Section
        label="Modelo Previvaz"
        valueText={previvazModel || 'Não definido'}
        open={openSection === 'previvaz'}
        onToggle={() => toggle('previvaz')}
      >
        <PrevivazModel />
      </Section>

      <Section
        label="Multi Cenários"
        valueText={countLabel(multiScenarios.length, 'm')}
        open={openSection === 'scenarios'}
        onToggle={() => toggle('scenarios')}
      >
        <MultiScenarios />
      </Section>

      {horizonsDisabled && (
        <p className="personalized-form-mobile-hint">
          O horizonte fica travado depois de adicionar o primeiro cenário.
        </p>
      )}

      <div className="upload-form-mobile-actions">
        {!horizonsDisabled && (
          <SheetActionButton
            variant="confirm"
            onClick={onAddScenarioClick}
            disabled={addScenarioDisabled}
          >
            Adicionar Cenário
          </SheetActionButton>
        )}
        <Button variant="link" onClick={onCancelClick}>
          Cancelar Estudo
        </Button>
      </div>
    </section>
  );
}
